// Sub paths for main app features.
export enum ROUTER_PATH {
  ROOT = "/",
  DOCUMENTS = "dokumenter",
  INTERVIEW = "intervju",
  MESSAGES = "meldinger",
  SIGN = "signer",
  SIGNING = "signering",
  SIGNED = "signert",
  WELCOME = "velkommen",
  BENEFICIARY = "begunstiget",
}

// Sub paths for welcome step
export enum INTRODUCTION_PATH {
  WELCOME = "velkommen",
  INFORMATION = "informasjon",
  COMPENSATION = "erstatning",
  LIMITATIONS = "begrensninger",
  CONSENT = "samtykke",
  READY = "klar",
}

// Paths to other STB apps.
export enum EXTERNAL_PATH {
  OVERVIEW = "oversikt",
  MY_INSURANCE_PAGES = "mine-forsikringssider",
}
